export const getDashboard = state => state.dashboard
export const getDashboardFavoriteDossiers = state => state.dashboard.dossierFavorites
export const getDashboardFavoriteTasks = state => state.dashboard.taskFavorites
export const getDashboardLastAccessedDossiers = state => state.dashboard.dossierLastAccessed
